define([], function () {
	'use strict';

	/**
	 * StateChangeInterceptor class
	 */
	return function () {
		// public methods

		this.intercept = function (previousState, nextState) {
			throw new Error('not implemented');
		};
	}
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/interceptor/StateChangeInterceptor.js
// module id = 174
// module chunks = 4